export const templatesIndex = {
  header: {
    title: "Modèles WhatsApp",
    description:
      "Créez et modifiez des modèles comme dans Meta (en-tête/corps/pied de page/boutons + aperçu).",
    create: "Créer un modèle",
  },
  notConnected:
    'Votre compte ne possède aucun WhatsApp Business connecté (WABA). Connectez-le en premier dans « WhatsApp Business ».',
  filters: {
    search: "Rechercher",
    searchPlaceholder: "Rechercher par nom...",
    status: "Statut",
    all: "Tous",
    category: "Catégorie",
    allFem: "Toutes",
    language: "Langue",
    refresh: "Actualiser",
  },
  list: {
    loading: "Chargement des modèles...",
    emptyTitle: "Aucun modèle",
    emptyText: "Essayez de modifier les filtres ou créez votre premier modèle.",
    baseBadge: "Base",
    edit: "Modifier",
    duplicate: "Dupliquer",
    deleteProtected: "Modèle de base : suppression impossible",
    delete: "Supprimer",
    prev: "← Précédent",
    next: "Suivant →",
  },
  preview: {
    noText: "(aucun texte)",
    noContent: "Aucun contenu",
  },
  time: {
    now: "Maintenant",
    minutesAbbr: "{n} min",
    hoursAbbr: "{n}h",
  },
  common: {
    close: "Fermer",
    cancel: "Annuler",
  },
  editor: {
    createTitle: "Créer un modèle",
    editTitle: "Modifier le modèle",
    sectionBasic: "Général",
    name: "Nom (snake_case)",
    nameHintHtml:
      "Les espaces deviennent <code>_</code>. Uniquement <code>a-z</code>, <code>0-9</code> et <code>_</code>.",
    language: "Langue",
    category: "Catégorie",
    sectionHeader: "En-tête",
    enable: "Activer",
    type: "Type",
    headerLocationHintHtml:
      "L'en-tête LOCATION ne contient ni texte ni exemples dans le modèle. La localisation (lat/lng + nom/adresse) est envoyée lorsque le message est remis via <code>/messages</code>.",
    headerMediaHint:
      "Si vous utilisez MEDIA, votre compte peut exiger des exemples/handles lors de la vérification.",
    headerTextLabel: "Texte (max 60)",
    headerTextPlaceholder: "Ex. Bonjour {{1}}, votre réservation est prête.",
    insert: "Insérer",
    autoExample: "Exemple auto",
    examplesHeader: "Exemples (en-tête)",
    remove: "Supprimer",
    headerLocationNote: "Une carte de localisation sera envoyée au début du message.",
    headerMediaNote: "Cet en-tête sera affiché comme une pièce jointe (média).",
    sectionBody: "Corps",
    bodyPlaceholder: "Rédigez le contenu. Utilisez {{1}}, {{2}}...",
    examplesBody: "Exemples (corps)",
    sectionFooter: "Pied de page",
    footerPlaceholder: "Texte court (facultatif, max 60)",
    sectionButtons: "Boutons",
    addButton: "+ Ajouter",
    noButtons: "Aucun bouton (facultatif).",
    buttonTextPlaceholder: "Texte du bouton (max 25)",
    removeButton: "Supprimer",
    previewTitle: "Aperçu",
    viewPayload: "Voir le payload envoyé à Meta",
    metaDebug: "Réponse / erreur de Meta (debug)",
    validReady: "Prêt à enregistrer.",
    validIncomplete: "Complétez les champs requis avant d'enregistrer.",
    saving: "Enregistrement...",
    save: "Enregistrer",
  },
  delete: {
    title: "Supprimer le modèle",
    irreversible: "Cette action est irréversible.",
    willDeletePre: "Le modèle ",
    willDeletePost: " sera supprimé.",
    confirmLabel: "Saisissez le nom exact pour confirmer :",
    confirmPlaceholder: "Saisissez le nom exactement",
    confirmHint: "Le bouton est activé lorsque le texte correspond exactement.",
    deleting: "Suppression...",
    confirmDelete: "Supprimer définitivement",
  },
  errors: {
    nameRequired: "Le nom est requis.",
    nameInvalid: "Format invalide. Utilisez uniquement a-z, 0-9 et _.",
    headerRequired: "Le texte de l'en-tête est requis si l'en-tête est activé.",
    headerMax: "Le texte de l'en-tête fait 60 caractères maximum.",
    bodyRequired: "Le corps est requis.",
    bodyMax: "Le corps fait 1024 caractères maximum.",
    footerMax: "Le pied de page fait 60 caractères maximum.",
    buttonTextRequired: "Le texte du bouton est requis.",
    buttonTextMax: "25 caractères maximum.",
    phoneInvalid: "PHONE_NUMBER doit être au format E.164 (ex. +34123456789).",
    urlInvalid: "L'URL doit commencer par http:// ou https://",
    loadDetail: "Impossible de charger les détails du modèle.",
    save: "Erreur lors de l'enregistrement du modèle.",
    deleteFailed: "Impossible de supprimer le modèle.",
  },
  duplicate: {
    defaultBody: "Copie du modèle. Modifiez le contenu. Merci {{1}}.",
  },
};
